import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useUserSettingsApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/usersettings', 'get');
    return { data, loading, error, refetch };
};
